export const uid = (prefix?: string) =>
  `${prefix ? `${prefix}_` : ''}${Date.now().toString(36) + Math.random().toString(36).substr(2)}`
